import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { TwoByTwoAxios } from "../Contracts/Axios/TwoByTwoAxios";
import { IServiceResult, IStoreExploreData } from "../Models/Models";
import { ITwoByTwo } from "../Models/Models";
import * as types from "./Types";

const loadTwoByTwoSuccess = (data: ITwoByTwo) => ({
    type: types.LOAD_TWO_BY_TWO_SUCCESS,
    data: data,
});

const loadTwoByTwoFailure = (data: ITwoByTwo) => ({
    type: types.LOAD_TWO_BY_TWO_FAILURE,
    data: data,
});
const exploreStoreSuccess = (data: IStoreExploreData) => ({
    type: types.EXPLORE_STORE_SUCCESS,
    data: data,
});

const exploreStoreFailure = (data: IStoreExploreData) => ({
    type: types.EXPLORE_STORE_FAILURE,
    data: data,
});

//Thunk Action
export const loadTwoByTwo: ActionCreator<ThunkAction<any, any, any, any>>
  = () => {
      return (dispatch: Dispatch<any>) => {
          const twoByTwoAxios = new TwoByTwoAxios();
          const promise = twoByTwoAxios.Get2x2();
          promise
              .then((response: IServiceResult<ITwoByTwo>) => {
                  dispatch(loadTwoByTwoSuccess(response.data));
              })
              .catch((error: any) => {
                  dispatch(loadTwoByTwoFailure(error));
              });
      };
  };

export const exploreStore: ActionCreator<ThunkAction<any, any, any, any>> = (
    sid: number,
    modelName: string
) => {
    return (dispatch: Dispatch<any>) => {
        const twoByTwoAxios = new TwoByTwoAxios();
        const promise = twoByTwoAxios.ExploreStore(sid);
        promise
            .then((response: IServiceResult<IStoreExploreData>) => {
                response.data.modelName = modelName;
                dispatch(exploreStoreSuccess(response.data));
            })
            .catch((error: any) => {
                dispatch(exploreStoreFailure(error));
            });
    };
};
